import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A datetime string with format `Y-m-d H:i:s`, e.g. `2018-05-23 13:43:32`. */
  DateTime: { input: any; output: any; }
};

export type AgentInfo = {
  agentName?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  outAgentId?: Maybe<Scalars['String']['output']>;
};

export type AirdropPermit = {
  amount?: Maybe<Scalars['String']['output']>;
  amountDecimal?: Maybe<Scalars['String']['output']>;
  permit?: Maybe<PermitDetail>;
  serviceFeeIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  tokenInfo?: Maybe<TokenDetailSimple>;
};

export type BeforeTrans = {
  tokenPrice?: Maybe<Scalars['String']['output']>;
};

export type CommentSimple = {
  imgUrl?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ConfigQueryResult = {
  airdropAddress?: Maybe<Scalars['String']['output']>;
  feeHandlerAddress?: Maybe<Scalars['String']['output']>;
  netSwapToolAddress?: Maybe<Scalars['String']['output']>;
  tokenFactoryAddress?: Maybe<Scalars['String']['output']>;
};

export type CreateCommentParam = {
  imgUrl?: InputMaybe<Scalars['String']['input']>;
  parentCommentId?: InputMaybe<Scalars['String']['input']>;
  replyCommentId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTokenParam = {
  address: Scalars['String']['input'];
  agentType: Scalars['String']['input'];
  airdropRate: Scalars['String']['input'];
  coBuildAgent?: InputMaybe<CoBuildAgentInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  imgUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sellAt: Scalars['String']['input'];
  symbol: Scalars['String']['input'];
  telegramLink?: InputMaybe<Scalars['String']['input']>;
  twitterLink?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreatorObj = {
  address?: Maybe<Scalars['String']['output']>;
  followedCnt?: Maybe<Scalars['String']['output']>;
  followingCnt?: Maybe<Scalars['String']['output']>;
  headImgUrl?: Maybe<Scalars['String']['output']>;
  nickName?: Maybe<Scalars['String']['output']>;
  telegramLink?: Maybe<Scalars['String']['output']>;
  twitterLink?: Maybe<Scalars['String']['output']>;
  walletType?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type FollowUser = {
  address?: Maybe<Scalars['String']['output']>;
  followAt?: Maybe<Scalars['String']['output']>;
  headImgUrl?: Maybe<Scalars['String']['output']>;
  nickName?: Maybe<Scalars['String']['output']>;
  telegramLink?: Maybe<Scalars['String']['output']>;
  twitterLink?: Maybe<Scalars['String']['output']>;
  walletType?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type LikeDetail = {
  clickUser?: Maybe<CreatorObj>;
  comment?: Maybe<CommentSimple>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  cancelFollowUser?: Maybe<Scalars['Boolean']['output']>;
  cancelServiceFee?: Maybe<Scalars['Boolean']['output']>;
  clickLike?: Maybe<Scalars['Boolean']['output']>;
  createComment?: Maybe<UserComment>;
  createToken?: Maybe<Token>;
  editUser?: Maybe<Scalars['Boolean']['output']>;
  followUser?: Maybe<Scalars['Boolean']['output']>;
  syncTokenTransaction?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationCancelFollowUserArgs = {
  targetUser?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelServiceFeeArgs = {
  serviceFeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationClickLikeArgs = {
  commentId?: InputMaybe<Scalars['String']['input']>;
  likedUser?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCommentArgs = {
  input: CreateCommentParam;
};


export type MutationCreateTokenArgs = {
  input: CreateTokenParam;
};


export type MutationEditUserArgs = {
  bio?: InputMaybe<Scalars['String']['input']>;
  headImgUrl?: InputMaybe<Scalars['String']['input']>;
  nickName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationFollowUserArgs = {
  targetUser?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSyncTokenTransactionArgs = {
  currencyAmount?: InputMaybe<Scalars['String']['input']>;
  currencyType?: InputMaybe<Scalars['String']['input']>;
  transactionHash?: InputMaybe<Scalars['String']['input']>;
  transactionType?: InputMaybe<Scalars['String']['input']>;
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

export type PageCommentList = {
  items?: Maybe<Array<Maybe<UserComment>>>;
  pagination?: Maybe<Pagination>;
};

export type PageFollowerList = {
  items?: Maybe<Array<Maybe<FollowUser>>>;
  pagination?: Maybe<Pagination>;
};

export type PageServiceFee = {
  items?: Maybe<Array<Maybe<ServiceFee>>>;
  pagination?: Maybe<Pagination>;
};

export type PageTokenList = {
  items?: Maybe<Array<Maybe<TokenDetail>>>;
  pagination?: Maybe<Pagination>;
};

export type PageTradingList = {
  items?: Maybe<Array<Maybe<TradingSingle>>>;
  pagination?: Maybe<Pagination>;
};

export type PageUserLike = {
  items?: Maybe<Array<Maybe<LikeDetail>>>;
  pagination?: Maybe<Pagination>;
};

export type PageUsers = {
  data?: Maybe<Array<Maybe<User>>>;
  pagination?: Maybe<Pagination>;
};

export type Pagination = {
  pageNum?: Maybe<Scalars['String']['output']>;
  pageSize?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['String']['output']>;
};

export type PermitDetail = {
  dataHash: Scalars['String']['output'];
  expire: Scalars['String']['output'];
  nonce: Scalars['String']['output'];
  permitType: Scalars['Int']['output'];
  sig: Scalars['String']['output'];
};

/** Indicates what fields are available at the top level of a query operation. */
export type Query = {
  boughtTokenList?: Maybe<Array<Maybe<TokenDetail>>>;
  configQuery?: Maybe<ConfigQueryResult>;
  followerList?: Maybe<PageFollowerList>;
  followingList?: Maybe<PageFollowerList>;
  getTokenPrice?: Maybe<Scalars['String']['output']>;
  myCoBuildTokenList?: Maybe<Array<Maybe<TokenDetail>>>;
  pageSearchTokenComment?: Maybe<PageCommentList>;
  pageSearchUserComment?: Maybe<PageCommentList>;
  serviceFeeAmount: Scalars['String']['output'];
  serviceFeeAmountTotal: Scalars['String']['output'];
  serviceFeePermit?: Maybe<AirdropPermit>;
  serviceFeeRecords?: Maybe<PageServiceFee>;
  tokenDetail?: Maybe<TokenDetail>;
  tokenHolders?: Maybe<Array<Maybe<TokenHolder>>>;
  tokenList?: Maybe<PageTokenList>;
  tradingList?: Maybe<PageTradingList>;
  userDetail?: Maybe<UserDetail>;
  userLikeList?: Maybe<PageUserLike>;
  userProfileInfo?: Maybe<UserProfileInfo>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryBoughtTokenListArgs = {
  user?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryFollowerListArgs = {
  pageNum: Scalars['String']['input'];
  pageSize: Scalars['String']['input'];
  user: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryFollowingListArgs = {
  pageNum: Scalars['String']['input'];
  pageSize: Scalars['String']['input'];
  user: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryGetTokenPriceArgs = {
  tokenId: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPageSearchTokenCommentArgs = {
  pageNum: Scalars['String']['input'];
  pageSize: Scalars['String']['input'];
  tokenId: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryPageSearchUserCommentArgs = {
  pageNum: Scalars['String']['input'];
  pageSize: Scalars['String']['input'];
  user: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryServiceFeeRecordsArgs = {
  pageNum: Scalars['String']['input'];
  pageSize: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryTokenDetailArgs = {
  tokenId?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryTokenHoldersArgs = {
  token: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryTokenListArgs = {
  agentType?: InputMaybe<Scalars['String']['input']>;
  coBuild?: InputMaybe<Scalars['Boolean']['input']>;
  creator?: InputMaybe<Scalars['String']['input']>;
  graduated?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  pageNum: Scalars['String']['input'];
  pageSize: Scalars['String']['input'];
  searchKey?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryTradingListArgs = {
  pageNum: Scalars['String']['input'];
  pageSize: Scalars['String']['input'];
  token: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryUserDetailArgs = {
  userAddress: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryUserLikeListArgs = {
  pageNum: Scalars['String']['input'];
  pageSize: Scalars['String']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryUserProfileInfoArgs = {
  userAddress: Scalars['String']['input'];
};

export type ServiceFee = {
  amount?: Maybe<Scalars['String']['output']>;
  bizId?: Maybe<Scalars['String']['output']>;
  bizType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  tokenInfo?: Maybe<TokenDetailSimple>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userAddress?: Maybe<Scalars['String']['output']>;
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export type Token = {
  /** Unique primary key. */
  address: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TokenDetail = {
  agentInfo?: Maybe<AgentInfo>;
  airdropActivityId?: Maybe<Scalars['String']['output']>;
  airdropAmount?: Maybe<Scalars['String']['output']>;
  airdropRate?: Maybe<Scalars['String']['output']>;
  beforeTrans?: Maybe<BeforeTrans>;
  category?: Maybe<Scalars['String']['output']>;
  collateral?: Maybe<Scalars['String']['output']>;
  contributeScore?: Maybe<Scalars['String']['output']>;
  createTimestamp?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<Scalars['String']['output']>;
  creatorObj?: Maybe<CreatorObj>;
  currencyAddress?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  daysVolume?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fundingGoal?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imgUrl?: Maybe<Scalars['String']['output']>;
  initialPrice?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nowPrice?: Maybe<Scalars['String']['output']>;
  pairAddress?: Maybe<Scalars['String']['output']>;
  remainSupply?: Maybe<Scalars['String']['output']>;
  replyCnt?: Maybe<Scalars['String']['output']>;
  sellAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
  telegramLink?: Maybe<Scalars['String']['output']>;
  tokenAmount?: Maybe<Scalars['String']['output']>;
  totalPrice?: Maybe<Scalars['String']['output']>;
  totalPriceUsd?: Maybe<Scalars['String']['output']>;
  totalSupply?: Maybe<Scalars['String']['output']>;
  transactionHash?: Maybe<Scalars['String']['output']>;
  twitterLink?: Maybe<Scalars['String']['output']>;
  updateTimestamp?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type TokenDetailSimple = {
  address?: Maybe<Scalars['String']['output']>;
  decimals?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
};

export type TokenHolder = {
  rate?: Maybe<Scalars['String']['output']>;
  tokenAmount?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userAddress?: Maybe<Scalars['String']['output']>;
  userImg?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type TradingSingle = {
  createTimestamp?: Maybe<Scalars['String']['output']>;
  currencyAmount?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  tokenAmount?: Maybe<Scalars['String']['output']>;
  transactionHash?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userAddress?: Maybe<Scalars['String']['output']>;
  userImg?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

/** Account of a person who utilizes this application. */
export type User = {
  /** Unique primary key. */
  address: Scalars['String']['output'];
  /** When the account was created. */
  content?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  /** When the email was verified. */
  head_img_url?: Maybe<Scalars['String']['output']>;
  /** Non-unique name. */
  nick_name?: Maybe<Scalars['String']['output']>;
  /** When the account was last updated. */
  updated_at: Scalars['DateTime']['output'];
  /** Unique email address. */
  wallet_type?: Maybe<Scalars['String']['output']>;
};

export type UserComment = {
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  loveCnt?: Maybe<Scalars['String']['output']>;
  parentCommentId?: Maybe<Scalars['String']['output']>;
  replyCommentId?: Maybe<Scalars['String']['output']>;
  replyImgUrl?: Maybe<Scalars['String']['output']>;
  replyUser?: Maybe<Scalars['String']['output']>;
  subCommentList?: Maybe<Array<Maybe<UserComment>>>;
  text?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
  userLiked?: Maybe<Scalars['Boolean']['output']>;
};

export type UserDetail = {
  address?: Maybe<Scalars['String']['output']>;
  followed?: Maybe<Scalars['Boolean']['output']>;
  followedCnt?: Maybe<Scalars['String']['output']>;
  followingCnt?: Maybe<Scalars['String']['output']>;
  headImgUrl?: Maybe<Scalars['String']['output']>;
  likeCnt?: Maybe<Scalars['String']['output']>;
  nickName?: Maybe<Scalars['String']['output']>;
  telegramLink?: Maybe<Scalars['String']['output']>;
  twitterLink?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type UserProfileInfo = {
  agentCount?: Maybe<Scalars['String']['output']>;
  followerCount?: Maybe<Scalars['String']['output']>;
  followingCount?: Maybe<Scalars['String']['output']>;
};

export type CoBuildAgentInput = {
  agentName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  greeting?: InputMaybe<Scalars['String']['input']>;
  knowledgeStr?: InputMaybe<Scalars['String']['input']>;
  knowledgeUrl?: InputMaybe<Scalars['String']['input']>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
};

export type TokenDetailQueryVariables = Exact<{
  tokenId: Scalars['String']['input'];
}>;


export type TokenDetailQuery = { tokenDetail?: { pairAddress?: string, collateral?: string, createTimestamp?: string, creator?: string, description?: string, id?: string, fundingGoal?: string, imgUrl?: string, name?: string, nowPrice?: string, remainSupply?: string, status?: string, currencyAddress?: string, symbol?: string, totalSupply?: string, transactionHash?: string, updateTimestamp?: string, totalPrice?: string, totalPriceUsd?: string, currencySymbol?: string, replyCnt?: string, sellAt?: string, airdropRate?: string, website?: string, twitterLink?: string, telegramLink?: string, tokenAmount?: string, daysVolume?: string, initialPrice?: string, creatorObj?: { address?: string, nickName?: string, walletType?: string, headImgUrl?: string, website?: string, twitterLink?: string, telegramLink?: string, followingCnt?: string, followedCnt?: string }, agentInfo?: { agentName?: string, outAgentId?: string }, beforeTrans?: { tokenPrice?: string } } };


export const TokenDetailDocument = gql`
    query tokenDetail($tokenId: String!) {
  tokenDetail(tokenId: $tokenId) {
    pairAddress
    collateral
    createTimestamp
    creator
    description
    id
    fundingGoal
    imgUrl
    name
    nowPrice
    remainSupply
    status
    currencyAddress
    symbol
    totalSupply
    transactionHash
    updateTimestamp
    totalPrice
    totalPriceUsd
    currencySymbol
    replyCnt
    creatorObj {
      address
      nickName
      walletType
      headImgUrl
      website
      twitterLink
      telegramLink
      followingCnt
      followedCnt
    }
    sellAt
    airdropRate
    website
    twitterLink
    telegramLink
    agentInfo {
      agentName
      outAgentId
    }
    tokenAmount
    daysVolume
    initialPrice
    beforeTrans {
      tokenPrice
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    tokenDetail(variables: TokenDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TokenDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TokenDetailQuery>({ document: TokenDetailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tokenDetail', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;